export default {
  max1880: "@media (max-width: 1880px)",
  max1800: "@media (max-width: 1800px)",
  max1700: "@media (max-width: 1700px)",
  max1640: "@media (max-width: 1640px)",
  max1520: "@media (max-width: 1520px)",
  max1400: "@media (max-width: 1400px)",
  max1280: "@media (max-width: 1280px)",
  max1100: "@media (max-width: 1100px)",
  max1024: "@media (max-width: 1024px)",
  max1000: "@media (max-width: 1000px)",
  max900: "@media (max-width: 900px)",
  max800: "@media (max-width: 800px)",
  max768: "@media (max-width: 768px)",
  max700: "@media (max-width: 700px)",
  max600: "@media (max-width: 600px)",
  max500: "@media (max-width: 500px)",
  max400: "@media (max-width: 400px)",
  max300: "@media (max-width: 300px)",
};
